import { useState } from 'react';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';
import { MultiSelectChips } from '@/components/shared/multi-select-chips';
import { LanguageLabels } from '@/constants/recommendation';
import { Language } from '@/models/recommendation';

interface LanguagesEditDialogProps {
  onClose: () => void;
  onSave: (languages: Language[]) => void;
  currentValues: Language[];
}

export const LanguagesEditDialog = ({
  currentValues,
  onClose,
  onSave,
}: LanguagesEditDialogProps) => {
  const [selectedLanguages, setSelectedLanguages] =
    useState<Language[]>(currentValues);

  const handleSave = () => {
    onSave(selectedLanguages);
  };

  const options = Object.values(Language).map((language) => {
    return {
      label: LanguageLabels[language],
      value: language,
    };
  });

  const handleToggle = (language: Language) => {
    const isSelected = selectedLanguages.includes(language);
    if (isSelected) {
      setSelectedLanguages(selectedLanguages.filter((l) => l !== language));
    } else {
      setSelectedLanguages([...selectedLanguages, language]);
    }
  };

  return (
    <ConfirmDialog
      actionLabels={{
        cancel: 'Cancelar',
        confirm: 'Salvar',
      }}
      onClose={onClose}
      open
      onConfirm={handleSave}
      title="Idiomas"
    >
      <MultiSelectChips
        options={options}
        currentValues={selectedLanguages}
        onToggle={handleToggle}
        shouldAnimate={false}
      />
    </ConfirmDialog>
  );
};
